import Layout from "../../layout/main";
import InternalReportsInventory from "../../components/internalReportsInventory";
/**
 * InternalReportsInventoryPage
 *
 * صفحه گزارش‌های داخلی موجودی که بخش مدیریت و نمایش اطلاعات موجودی داخلی را ارائه می‌دهد.
 * این صفحه از Layout اصلی برای ساختار کلی اپلیکیشن استفاده می‌کند.
 *
 * ویژگی‌ها:
 * - استفاده از Layout برای یکپارچگی طراحی
 * - نمایش کامپوننت InternalReportsInventory برای مدیریت و مشاهده گزارش‌های موجودی داخلی
 *
 * @returns JSX.Element
 */

const InternalReportsInventoryPage = () => {
  return (
    <Layout>
      <InternalReportsInventory />
    </Layout>
  );
};

export default InternalReportsInventoryPage;
